/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import Image from 'material/embeds/imageapi/imagepane/image/image_container';
import Loading from 'material/embeds/imageapi/imagepane/loading/loading';
//utils
import { giphyCancel, defaultQuery } from 'utils/api/embed'
import { GIPHY } from 'state/actions/embedsState/embedManagementState/image_status';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/pane/giphys/giphys_styles';



/* ========== ~~~~~~~~~~ GIPHY ~~~~~~~~~~ ========== */
class Giphys extends Component {
	constructor(props) {
		super(props);
		this.state={selected: null};
		this.processGiphySearch=this.processGiphySearch.bind(this);
		this.handleSelect=this.handleSelect.bind(this);
	};
	
	componentDidMount(){
		this.processGiphySearch(this.props.query, this.props.page);
	}

	componentDidUpdate(prevProps){
		if (prevProps.query !== this.props.query || prevProps.page !== this.props.page){
			this.processGiphySearch(this.props.query, this.props.page);
		} 
	}

	componentWillUnmount(){
		if (!this.props.isDataReceived){
			giphyCancel();
		}
	}

	processGiphySearch(query, page){
		if (query==''){
			this.props.getGiphy(defaultQuery, page);
		} else {
			this.props.getGiphy(query, page);
		}
	}

	handleSelect(id){
		this.setState({selected: id});
	}

	renderImages() {
			return this.props.images.data.map((image, i) => {
				return (		
					<span className={`imagecontainer`} key={image.id} onClick={() => this.handleSelect(image.id)}>
						<Image key={`giphy-image-${image.id}`} clicked={image.id === this.state.selected} provider={GIPHY} id={null}
							previewUrl={image.images.fixed_height.url}
							url={image.images.fixed_height.url} />
					</span>
				)
			});
	};

	render() {
		return (
			<div className={`pane giphys ${this.props.classes.giphys}`}>
				{(this.props.provider === GIPHY && this.props.isDataReceived && this.props.images.length > 0 && !this.props.error) ? <div className={`innerPane`}>
					{this.renderImages()}
				</div> : <Loading error = {this.props.error} images={(this.props.isDataReceived && this.props.images.length === 0)} />}
			</div>
		)
	};
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Giphys);
